import {
  DEFAULT_MARKET_COUNTRY,
  MARKET_COUNTRY_STORAGE_KEY,
  type MarketCountry,
  isMarketCountry,
  normalizeMarketCountry,
} from "./marketCountry";
import {
  clearMarketCountryCookie,
  readMarketCountryCookie,
  writeMarketCountryCookie,
} from "./marketCountryCookie";

export function resolveInitialMarketCountry(): MarketCountry {
  const fromCookie = readMarketCountryCookie();
  if (fromCookie) {
    return fromCookie;
  }
  return readStoredMarketCountry();
}

export function readStoredMarketCountry(): MarketCountry {
  if (typeof window === "undefined") {
    return DEFAULT_MARKET_COUNTRY;
  }

  try {
    return normalizeMarketCountry(window.localStorage.getItem(MARKET_COUNTRY_STORAGE_KEY));
  } catch {
    return DEFAULT_MARKET_COUNTRY;
  }
}

export function writeStoredMarketCountry(marketCountry: MarketCountry): void {
  if (typeof window === "undefined") {
    return;
  }

  const normalized = normalizeMarketCountry(marketCountry);

  try {
    window.localStorage.setItem(MARKET_COUNTRY_STORAGE_KEY, normalized);
  } catch {
    /* ignore quota / private mode */
  }

  writeMarketCountryCookie(normalized);
}

export function clearStoredMarketCountry(): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(MARKET_COUNTRY_STORAGE_KEY);
  } catch {
    /* ignore */
  }

  clearMarketCountryCookie();
}

export function readAnonymousMarketCountry(): MarketCountry {
  return resolveInitialMarketCountry();
}

export { isMarketCountry };
